var React = require('react');

function Swoop90 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M292.167 0.5H0.5C0.5 161.763 131.087 292.5 292.167 292.5L583.833 292.5H681.056H706.4H875.5C875.5 131.493 744.656 0.5 583.833 0.5L438.009 0.5H292.167Z","fill":"currentColor"}));
}

Swoop90.defaultProps = {"width":"876","height":"293","viewBox":"0 0 876 293","fill":"none"};

module.exports = Swoop90;

Swoop90.default = Swoop90;
